import {AfterViewInit, Component, OnInit, ViewEncapsulation} from '@angular/core';
import {CoinModelSendSignal} from "../../../../_models/send-signal";
import {DialogComponent, DialogService} from "ng2-bootstrap-modal";
import {SendSignalService} from "../../../../_services/send-signal.service";
import {AlertBoxComponent} from "../../../../_common/alert-box/alert-box.component";

@Component({
    selector: 'app-popup-coin-send-for-user',
    templateUrl: './popup-coin-send-for-user.component.html',
    styleUrls: ['../../send-signal-event.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class PopupCoinSendForUserComponent extends DialogComponent<CoinModelSendSignal, boolean> implements AfterViewInit, OnInit {
    loading = false;
    model: any = {};
    titlePopup: string;
    lineBotID: number;
    codeSendSignalEvent: string;
    strErrorSendSignalName: string = '';
    strErrorListCoin: string = '';
    // Active
    defaultBlockActive: number = 0;
    listCoinSendSignal: any = {};
    listCoinEvent: any = [];
    listLineCoinBot: any;
    data: any;
    isFromValidate: boolean = false;
    constantSendSignal: any;

    constructor(dialogService: DialogService, private sendSignalService: SendSignalService) {
        super(dialogService);
    }

    ngOnInit() {
        this.listLineCoinBot = this.listCoinSendSignal.listLineBotCoinActive;
        this.listCoinEvent = this.listCoinSendSignal.listCoinEventActive;
        // Data
        this.model.sendSignalName = this.data && this.data.hasOwnProperty('send_signal_name') ? this.data.send_signal_name : '';
        this.model.blockActive = this.data && this.data.hasOwnProperty('is_active') ? this.data.is_active : this.defaultBlockActive;
    }

    ngAfterViewInit() {
        let self = this;
        setTimeout(() => {
            self.checkBoxAll();
        });
    }

    checkAllList(event) {
        let self = this;
        self.listCoinEvent = [];
        this.listLineCoinBot.map((elem, index) => {
            if (event.target.checked) {
                self.listCoinEvent.push(+elem.coin_id);
                $('#check-box-' + elem.coin_id).attr('checked', 'checked');
            } else {
                $('#check-box-' + elem.coin_id).attr('checked', '');
            }
        });

        if (!event.target.checked) {
            self.listCoinEvent = [];
        }

        this.customValidate();
    }

    toggleSelection(event: any) {
        let value = event.target.dataset.value;
        let checkExist = this.checkedBox(+value);
        if (checkExist) {
            // Is currently selected
            this.listCoinEvent.splice(this.listCoinEvent.indexOf(+value), 1);
        } else {
            // Is newly selected
            this.listCoinEvent.push(+value);
        }

        this.checkBoxAll();
        this.customValidate();
    }

    checkBoxAll() {
        $('#check-all-coin').prop('checked', (this.listCoinEvent.length == this.listLineCoinBot.length ? 'checked' : ''));
    }

    checkedBox(value) {
        return this.listCoinEvent.indexOf(+value) != -1;
    }

    updateOrCreateSignalForUser() {
        let self = this;
        self.loading = true;
        if (self.customValidate()) {
            self.getDataModel(model => {
                self.sendSignalService.postCreateOrUpdateEventForUser(model).subscribe(resData => {
                    self.loading = false;
                    self.isFromValidate = false;
                    if (resData.hasOwnProperty('result') && resData.result == false) {
                        if (resData.hasOwnProperty('type') && resData.type === '_FAIL_') {
                            if (resData.hasOwnProperty('error')) {
                                self.dialogService.addDialog(AlertBoxComponent, {message: resData.error}).subscribe((result) => {
                                    self.close();
                                });
                            }
                        }
                    } else if (resData.hasOwnProperty('result') && resData.result == true) {
                        if (resData.hasOwnProperty('type') && (resData.type === '_VALIDATE_')) {
                            self.strErrorSendSignalName = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('sendSignalName')) ? resData.error.sendSignalName[0] : '';
                            self.strErrorListCoin = (resData.hasOwnProperty('error') && resData.error.hasOwnProperty('listCoinEventForUser')) ? resData.error.listCoinEventForUser[0] : '';
                        } else if (resData.hasOwnProperty('type') && (resData.type === '_SUCCESS_')) {
                            self.isFromValidate = true;
                            this.result = true;
                            self.close();
                        }
                    }
                }, error => {
                    self.isFromValidate = false;
                });
            });
        }
    }

    keyUpCharacterEventName(event: any) {
        this.strErrorSendSignalName = (event.target.value || '').length ? '' : 'イベント名が空白にならない。';
        this.customValidate();
    }

    customValidate() {
        let self = this;
        this.strErrorListCoin = this.listCoinEvent.length ? '' : 'コインを選択一覧が空ではいけません。';
        let cusFromValidate = false;
        let eventName = this.model.sendSignalName.trim().length;
        let listCoinID = this.listCoinEvent.length;

        cusFromValidate = (!cusFromValidate && eventName && self.strErrorSendSignalName.length == 0) ? true : false;
        cusFromValidate = (cusFromValidate && listCoinID && self.strErrorListCoin.length == 0) ? true : false;

        self.isFromValidate = cusFromValidate;
        return self.isFromValidate;
    }

    getDataModel(callback: any) {
        let self = this;
        // Set model
        self.model.listCoinEventForUser = this.listCoinEvent.join(',');
        self.model.lineBotID = +this.lineBotID;
        self.model.codeSendSignalEvent = this.codeSendSignalEvent;

        callback(self.model);
    }

    changeValActiveEvent(event: any) {
        this.model.blockActive = event.target.value != this.constantSendSignal.statusEvent.stopped
            ? this.constantSendSignal.statusEvent.stopped
            : this.constantSendSignal.statusEvent.active;

        this.isFromValidate = true;
    }
}



// WEBPACK FOOTER //
// C:/Users/El-Nino/Desktop/coin-alert-test/AngularCoinAlert/src/app/_components/send-signal-event/manage-coin-send-for-user/popup-coin-send-for-user/popup-coin-send-for-user.component.ts